<script lang="ts">
  import {onMount} from 'svelte';

  let component;

  onMount(() => {
    loadHeaderComponent();
  });

  async function loadHeaderComponent() {
    setTimeout(() => {
      import('./HeaderContent.svelte').then((response) => {
        component = response && response.default;
      });
    }, 100);
  }
</script>

<style>
  .header-place {
    border-bottom: 1px solid #eee;
    height: 64px;
    min-height: 64px;
    background-color: #ffffff;
  }

  @media screen and (max-width: 640px) {
    .header-place {
      height: unset;
      min-height: unset;
    }
  }
</style>

<div class="header-place" hidden={component} />
<svelte:component this={component} {...$$props}>
  <div slot='web3Right' let:isTop={isTop} let:isOpacityHeader={isOpacityHeader}>
    <slot name='web3Right' isTop={isTop} isOpacityHeader={isOpacityHeader}/>
  </div>
</svelte:component>
